// extracted by mini-css-extract-plugin
export default {"title":"styles_title__BkYS9","containerOption":"styles_containerOption__6Hos6"};